import { DownloadOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Card, Col, Image, List, Row } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { BASE_API_CONFIG } from "../../util/Api";
import { useDispatch, useSelector } from "react-redux";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { isArrayNonEmpty } from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { Typography } from "antd";

const ViewCompleteDetails = () => {
  const history = useHistory();
  const { id } = useParams();
  const [policyData, setPolicyData] = useState(null);
  const [fileName, setFileName] = useState(null);
  const authUser = useSelector(({ auth }) => auth.userData);
  const token = authUser.token;
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();
  const { Title } = Typography;
  const [referencedocs, setReferenceDocs] = useState(null);

  const fetchpolicyDetailsById = async () => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(
        `${BASE_API_CONFIG.baseURL}/policyUpdate/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(fetchSuccess());
      setPolicyData(response.data);
    } catch (error) {
      console.error("Error fetching policy details:", error);
    }
  };

  useEffect(() => {
    fetchpolicyDetailsById();
  }, []);


  useEffect(() => {
    if (isArrayNonEmpty(policyData?.policyIcon)) {
      const fileNames = policyData?.policyIcon?.map((image) => {
        return image;
      });
      setFileName(fileNames);
    }
  }, [policyData]);

  useEffect(() => {
    if (isArrayNonEmpty(policyData?.referenceDocument)) {
      const fileNames = policyData?.referenceDocument?.map((image) => {
        return image;
      });
      setReferenceDocs(fileNames);
    }
  }, [policyData]);

  return (
    <Card className="myexim-detail-card">
      <div
        className="myexim-table-title"
        style={{ display: "flex", alignItems: "center", gap: "12px" }}
      >
        <div
          onClick={() => {
            history.goBack();
          }}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <LeftOutlined style={{ fontSize: "24px" }} size="large" />
        </div>
        <Title
          level={5}
          style={{
            margin: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          {policyData?.title} - ({policyData?.details})
        </Title>
      </div>

      <div className="wrapper" style={{ marginTop: "20px",marginLeft:"32px" }}>
        {fileName?.length > 0 && (
          <div style={{ float: "left", marginRight: "20px" }}>
            {fileName?.map((fileName, index) => (
              <div key={index} style={{ marginBottom: "16px" }}>
                <Image
                  style={{
                    maxWidth: "250px",
                    height: "250px",
                    objectFit: "contain",
                  }}
                  src={fileName?.src}
                />
              </div>
            ))}
          </div>
        )}
        <div className="text-box">
          <p>{policyData?.description} </p>
        </div>
      </div>

      <div style={{ marginTop: "50px", marginLeft: "32px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
            gridTemplateRows: "auto auto",
            gap: "24px",
            marginTop: "24px",
          }}
        >
          {referencedocs?.length > 0 && (
            <div style={{ gridRow: "1 / 2", gridColumn: "1 / 2" }}>
              <div className="attachments">
                <Title
                  level={5}
                  style={{
                    justifyContent: "left",
                    display: "flex",
                    marginBottom: "0px",
                  }}
                >
                  Reference Document
                </Title>
                <div className="gx-pt-4">
                  {referencedocs?.map((fileName, index) => (
                    <div key={index} className="gx-pb-3">
                      <div className="gx-pt-2">
                        <a
                          href={fileName?.downloadUrl || fileName?.src}
                          download={fileName?.originalName}
                          className="download-link"
                          style={{
                            color: "#1677ff",
                            display: "flex",
                            alignItems: "center",
                            gap:"4px",
                          }}
                        >
                          <DownloadOutlined style={{ fontSize: "18px" }} />
                          <span>
                            {fileName?.originalName ||
                              `Document-${index + 1}.pdf`}
                          </span>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <br></br>
      <div style={{ marginLeft: "35px" }}>
        <div
          style={{ justifyContent: "right", display: "flex", flex: 1 }}
          className="gx-pt-4"
        >
          <Button
            type="secondary"
            size="large"
            onClick={() => {
              history.goBack();
            }}
            className="submit-btn"
          >
            Back
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ViewCompleteDetails;
